import {CustomCode} from "./common.model";


export class ModuleType extends CustomCode{
  public static _registered = new Map<string, ModuleType>();
  //
  static SENIORITY_MODULE = new ModuleType('SENIORITY_MODULE');
  static PAY_V2_MODULE  = new ModuleType('PAY_V2_MODULE');
  static PLANNING_MODULE  = new ModuleType('PLANNING_MODULE');
  static BERMEX_MODULE  = new ModuleType('BERMEX_MODULE');
  //Emprez
  static SCHEDULE_MODULE  = new ModuleType('SCHEDULE_MODULE');
  static TIMESHEET_MODULE  = new ModuleType('TIMESHEET_MODULE');
  static PAY_MODULE  = new ModuleType('PAY_MODULE');
  static PERFORMANCE_MODULE  = new ModuleType('PERFORMANCE_MODULE');
 static EXPENSE_MODULE = new ModuleType('EXPENSE_MODULE');
  static HR_MODULE = new ModuleType('HR_MODULE');

  static ALL_HORARIUS_EMPREZ = Array.from(ModuleType._registered.values());

  static ALL = [ModuleType.SCHEDULE_MODULE,ModuleType.TIMESHEET_MODULE,ModuleType.PAY_MODULE,ModuleType.PERFORMANCE_MODULE,ModuleType.EXPENSE_MODULE,ModuleType.HR_MODULE];

  constructor (code: string) {
    super(code);
    ModuleType._registered.set(code, this);
  }


  static retrieveFromCode(code: string): ModuleType {
    const res = ModuleType._registered.get(code);
    if (!res) {
      console.log('ModuleType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  toTranslateKey():string{
    return 'MODULE_TYPE_' + this.code;
  }

}
